import { WorkspacePermission } from 'src/redux/workspaces/constants';
import { urls } from 'src/urls';

export async function hasWorkspaceAdminStatus(
  workspaceSlug: string
): Promise<boolean | undefined> {
  try {
    const url = urls.api.v20.workspacePermission(workspaceSlug);

    const resp = await fetch(url);
    if (resp.ok) {
      const { permission } = await resp.json();
      return permission === WorkspacePermission.Owner;
    }
  } catch {
    // no need to log error, just return undefined as workspace admin status unknown
    return undefined;
  }
  // by default return undefined as workspace admin status unknown
  return undefined;
}
